import axios from "axios";

export const getBlob = async (
  url: string,
  callback?: (progress: any) => void
) => {
  return await axios.get(url, {
    responseType: "blob",
    onDownloadProgress: (progress: any) => {
      callback?.(progress);
    },
  });
};
